import { render, staticRenderFns } from "./WalletCard.htm?vue&type=template&id=989978c2&scoped=true&"
import script from "./WalletCard.ts?vue&type=script&lang=js&"
export * from "./WalletCard.ts?vue&type=script&lang=js&"
import style0 from "./WalletCard.scss?vue&type=style&index=0&id=989978c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989978c2",
  null
  
)

export default component.exports